/*
 * VNCcommander - The brilliant centerpiece of VNClagoon with your activity stream and much more.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ConfigService } from "../config.service";
import { environment } from "src/environments/environment";
import { ElectronService } from "../services/electron.service";
import { take } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "vp-authentication",
  templateUrl: "./vnc-authentication.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class VNCAuthenticationComponent implements OnInit, AfterViewInit {
  backgroundImage = "url('assets/images/login-background.png')";
  serverURL = "https://commander.vnc.biz";
  @ViewChild("urlInput") urlInput: ElementRef;
  constructor(private http: HttpClient,
    private translate: TranslateService,
              private configService: ConfigService,
              private electronService: ElectronService) {
    const serverUrl = this.electronService.isElectron
        ? this.electronService.getFromStorage("serverUrl")
        : localStorage.getItem("serverURL");
    if (serverUrl !== null && serverUrl !== undefined ) {
      this.serverURL = serverUrl;
    }
  }

  static getBaseUrl() {
    const baseUrl = window.location.href;

    if (environment.isCordova) {
      return baseUrl.split("/www/")[0] + "/www";
    } else if (environment.isElectron) {
      return baseUrl.includes("/index.html") ? baseUrl.split("/index.html")[0] : baseUrl.split("/mail")[0];
    } else {
      return "";
    }
  }

  ngAfterViewInit() {
  
    if (typeof navigator !== "undefined" && navigator.splashscreen) {
      navigator.splashscreen.hide();
    }
    setTimeout(() => {
      this.urlInput.nativeElement.focus();
    }, 200);
  }


  getFullUrl(url: string) {
    const baseUrl = window.location.href;

    if (environment.isCordova) {
      return window.location.href.split("/www/")[0] + "/www" + url;
    } else if (environment.isElectron) {
      return (baseUrl.includes("/index.html") ? baseUrl.split("/index.html")[0] : baseUrl.split("/mail")[0]) + url;
    } else {
      return url;
    }
  }

  ngOnInit() {
   
  }

  loginNewServer() {

    const headers = new HttpHeaders({ "Content-Type": "application/json" });
    if (this.serverURL.endsWith("/")) {
      this.serverURL = this.serverURL.substring(0, this.serverURL.lastIndexOf("/")).trim();
    }
    let errorMsg = "The Server URL entered by you is wrong. Please provide correct URL";
    this.translate.get("WRONG_SERVER_URL_ERR_MSG").pipe(take(1)).subscribe(text => {
      if (errorMsg !== "WRONG_SERVER_URL_ERR_MSG") {
        errorMsg = text;
      }
    });
    this.http.get<any>(this.serverURL + "/api/config", { headers: headers })
      .subscribe(data => {
       
        if (data.federatedApps && data.federatedApps["VNCtalk"]) {
          this.configService.API_URL = this.serverURL;
          this.setServerURL(this.configService.API_URL);
        } else {
          alert(errorMsg);
        }
      }, (err) => {
      
        alert(errorMsg);
      });
  }

  loginDemoServer() {
    // this.setServerURL(this.configService.DEMO_URL);
  }

  setServerURL(url) {
    if (url) {
      if (!url.startsWith("http")) {
        url = "";
      }
      this.configService.setAPIURL(url);
      let serverURL;
      if (this.electronService.isElectron) {
        this.electronService.clearStorage();
        serverURL = this.electronService.getFromStorage("serverURL");
      } else {
        localStorage.clear();
        serverURL = localStorage.getItem("serverURL");
      }

      if (this.electronService.isElectron) {
        this.electronService.setToStorage("serverURL", url.trim());
      }

      localStorage.setItem("serverURL", url.trim());

      if (!!serverURL) {
        this.configService.selectedServer = true;
        this.configService.loginIframe();
      } else {
        let initialHref = window.location.href.split("/www/")[0];
        window.location.href = `${initialHref}${environment.isCordova ? "/www" : ""}/index.html`;
      }
    }
  }

}
